import { Box, Typography, Grid, Button } from "@mui/material";
import about from "../../../assests/images/about.jpg";
import { useNavigate } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";

const AboutUs = () => {

  const navigate = useNavigate()
  const { token } = useAuth();

  return (
    <Grid
      container
      sx={{
        alignItems: "center",
        justifyContent: "space-between",
        height: "80vh",
        padding: 3,
        backgroundColor: "#fff", // This matches the background color of the example image
      }}
    >
      <Grid item xs={12} md={6}>
        <Box
          sx={{
            p: 3,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "#990000",
              mb: 2,
            }}
          >
            About Us
          </Typography>
          <Typography variant="h2" sx={{ fontWeight: "bold", mb: 2 }}>
            Securing Your Future with Unmatched Safety.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Cyberbank stands synonymous with trust, ensuring your financial
            assets are protected by industry-leading security. We provide a
            sanctuary for your finances, where every deposit and transaction is
            safeguarded with utmost care. Bank with confidence and embrace a
            future of stability and security with Cyberbank, your partner in
            financial resilience.
          </Typography>
          {token
            ?
            <Button
              variant="contained"
              color="primary"
              sx={{
                alignSelf: "start",
                backgroundColor: "#990000", // Apply the custom color here
                "&:hover": {
                  backgroundColor: "#7a0000", // Darken the color slightly on hover
                },
              }}
              onClick={() => navigate("/banking")}
            >
              Banking
            </Button> :
            <Button
              variant="contained"
              color="primary"
              sx={{
                alignSelf: "start",
                backgroundColor: "#990000", // Apply the custom color here
                "&:hover": {
                  backgroundColor: "#7a0000", // Darken the color slightly on hover
                },
              }}
              onClick={() => navigate("/sign-up")}
            >
              Sign Up for Free
            </Button>}
          <Button
            variant="contained"
            color="primary"
            sx={{
              alignSelf: "start",
              backgroundColor: "#990000", // Apply the custom color here
              "&:hover": {
                backgroundColor: "#7a0000", // Darken the color slightly on hover
              },
              mt: 1,
            }}
            onClick={() => navigate("/contact")}
          >
            contact us
          </Button>
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        <Box
          component="img"
          sx={{
            maxWidth: "90%",
            height: "auto",
            borderRadius: "8px", // Rounded corners as in the example image
          }}
          alt="Cyberbank Building"
          src={about}
        />
      </Grid>
    </Grid>
  );
};

export default AboutUs;
